import MercuryImage from './images/Mercury1.png';
import VenusImage from './images/Venus1.png';
import EarthImage from './images/Earth1.png';
import NeptuneImage from './images/Neptune1.png';
import MarsImage from './images/Mars1.png'
import JupiterImage from './images/Jupiter1.png';
import SaturnImage from './images/Saturn1.png';
import UranusImage from './images/Uranus1.png';

const MenuItems = [
  {
    title: 'MERCURY',
    url: '#',
    cName: 'nav-links',
    imgSrc: MercuryImage,
    color: '#419EBB',
  },
  {
    title: 'VENUS',
    url: '#',
    cName: 'nav-links',
    imgSrc: VenusImage,
    color: '#EDA249', // Use the imported module directly
  },
  {
    title: 'EARTH',
    url: '#',
    cName: 'nav-links',
    imgSrc: EarthImage,
    color: '#6D2ED5',
  },
  {
    title: 'MARS',
    url: '#',
    cName: 'nav-links',
    imgSrc: MarsImage,
    color: '#D14C32',
  },
  {
    title: 'JUPITER',
    url: '#',
    cName: 'nav-links',
    imgSrc: JupiterImage,
    color: '#D83A34',
  },
  {
    title: 'SATURN',
    url: '#',
    cName: 'nav-links',
    imgSrc: SaturnImage,
    color: '#CD5120',
  },
  {
    title: 'URANUS',
    url: '#',
    cName: 'nav-links',
    imgSrc: UranusImage,
    color: '#1EC1A2',
  },
  {
    title: 'NEPTUNE',
    url: '#',
    cName: 'nav-links',
    imgSrc: NeptuneImage,
    color: '#2D68F0', // Use the imported module directly
  }
];

export default MenuItems;
